import React, { useEffect } from 'react'
import { useFormikContext } from 'formik'

import { SourceField } from 'src/legacy/components/fields'
import { usePatientSource } from '../../usePatientSource'

type Props = {
  uid: string
}
const PreselectedSourceField = ({ uid }: Props) => {
  const { setFieldValue } = useFormikContext()
  const { source } = usePatientSource(uid)

  useEffect(() => {
    if (source) {
      setFieldValue('source', source)
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [source])

  return <SourceField />
}

export default PreselectedSourceField
